const $inject = ['$q', '$http'];

const indexService = function ($q, $http) {
  let service = {};

  service.search = function search(uri, index, suggestor, apiVersion, expression, searchFields, returnFields, uniqueField, identifier) {
    let deferred = $q.defer();

    if (!expression){
        deferred.reject();
        return deferred.promise;
    }

    const searchFieldsCommaSeparated = searchFields.join(',');
    const returnFieldsCommaSeparated = returnFields.join(',');

    const qs = `${uri.url}/indexes/${index}index/docs/suggest?suggesterName=${suggestor}&search=${expression}&searchFields=${searchFieldsCommaSeparated}`+
            `&$select=${returnFieldsCommaSeparated}&fuzzy=false&api-version=${apiVersion}&api-key=${uri.key}&$filter=DebtorCode eq '${identifier}'`;
       
    $http.get(qs)
      .success(function (data) {
        let responseData = _.uniqBy(data.value, uniqueField) || _.uniqBy(data, uniqueField);
        deferred.resolve(responseData);

      })

      .error(function (err, x) {
        deferred.reject(err);
      });

    return deferred.promise;
  };

  return service;
};

indexService.$inject = $inject;

export default indexService;



// WEBPACK FOOTER //
// ./src/services/indexService.js